"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useTrackEvent;

var _react = require("react");

var _createCustomEvent = _interopRequireDefault(require("../Utils/createCustomEvent"));

var _useReadTelemetryDimensions = _interopRequireDefault(require("./internal/useReadTelemetryDimensions"));

var _useWebChatUIContext2 = _interopRequireDefault(require("./internal/useWebChatUIContext"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function isNonNegativeFiniteNumberOrString(value) {
  return typeof value === 'number' && isFinite(value) && value >= 0 || typeof value === 'string';
}

function isObject(value) {
  return Object.prototype.toString.call(value) === '[object Object]';
}

function useTrackEvent() {
  var _useWebChatUIContext = (0, _useWebChatUIContext2.default)(),
      onTelemetry = _useWebChatUIContext.onTelemetry;

  var readTelemetryDimensions = (0, _useReadTelemetryDimensions.default)();
  var trackEvent = (0, _react.useCallback)(function (level, name, data) {
    if (!name || typeof name !== 'string') {
      return console.warn('botframework-webchat: "name" passed to "useTrackEvent" hook must be a string.');
    }

    if (typeof data !== 'undefined') {
      if (isObject(data)) {
        if (!Object.values(data).every(function (value) {
          return isNonNegativeFiniteNumberOrString(value);
        })) {
          return console.warn('botframework-webchat: Every value in "data" map passed to "useTrackEvent" hook must be a non-negative finite number or string.');
        }
      } else if (!isNonNegativeFiniteNumberOrString(data)) {
        return console.warn('botframework-webchat: "data" passed to "useTrackEvent" hook must be a non-negative finite number or string.');
      }
    }

    onTelemetry && onTelemetry((0, _createCustomEvent.default)('event', {
      data: data,
      dimensions: readTelemetryDimensions(),
      level: level,
      name: name
    }));
  }, [onTelemetry, readTelemetryDimensions]);
  return (0, _react.useMemo)(function () {
    var info = trackEvent.bind(null, 'info');
    info.debug = trackEvent.bind(null, 'debug');
    info.error = trackEvent.bind(null, 'error');
    info.info = info;
    info.warn = trackEvent.bind(null, 'warn');
    return info;
  }, [trackEvent]);
}